import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-on-vacation',
  templateUrl: './on-vacation.component.html',
  styleUrls: ['./on-vacation.component.scss'],
})
export class OnVacationComponent implements OnInit {

  constructor(private modalCtrl: ModalController, private ws: PtyWsService, public navParams: NavParams) { }

  ngOnInit() {

  }

  switch() {
    const self = this;
    self.ws.invokeURL('set_Vacation', { vacation_uuid: this.navParams.get('vacation_uuid') }).subscribe((result: any) => {
      if (result.user.vacation_uuid) {
      } else {
        this.modalCtrl.dismiss({
          'dismissed': true,
        });
      }
    });
  }

}
